import { createSlice } from "@reduxjs/toolkit";

export const readchatAgentMessage = createSlice({
  name: "readchatAgentMessage",
  initialState: {
    value: false,
  },
  reducers: {
    changeAgentReadchatMessage: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { changeAgentReadchatMessage } = readchatAgentMessage.actions;
export const currentAgentReadchatMessage = (state) => state.readchatAgentMessage.value;
export default readchatAgentMessage.reducer;
